import { render, staticRenderFns } from "./AbLoader.vue?vue&type=template&id=8b73ab4c&scoped=true"
import script from "./AbLoader.vue?vue&type=script&lang=js"
export * from "./AbLoader.vue?vue&type=script&lang=js"
import style0 from "./AbLoader.vue?vue&type=style&index=0&id=8b73ab4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b73ab4c",
  null
  
)

export default component.exports